export default __webpack_public_path__ + "atomic/_patterns/01-atoms/quote/_quote-organisation.twig";